import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import '@/index.css';
import { Toaster } from '@/components/ui/toaster';

if (import.meta?.env?.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => reg.unregister());
  });
  caches.keys().then(keys => {
    keys.forEach(key => caches.delete(key));
  });
}

// A prerendered page (scripts/prerender.mjs) is already on screen when this
// bundle runs, and createRoot clears it on the first commit. A page that then
// waits on data would show a blank in between, so what was there is kept for
// any page that wants to draw it while it loads (the part pages do).
const rootEl = document.getElementById('root');
if (rootEl.children.length) {
  window.__prerendered = { path: window.location.pathname, html: rootEl.innerHTML };
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
    <Toaster />
  </React.StrictMode>
);